import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import Grid from 'components/Grid/GridContainer.jsx'
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import style from "assets/css/style.jsx"
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import ListItemText from '@material-ui/core/ListItemText';
import api from 'api'
import CardActions from '@material-ui/core/CardActions';
import {Link} from "react-router-dom";
import CardHeader from 'components/Card/CardHeader.jsx'
import logo from '../../assets/pdf.png'
import CircularProgress from '@material-ui/core/CircularProgress';

class RecapParticipation extends React.Component {
    state = {
        user: null,
        media:null,
        stop:false,
        dataArray:[],
        arrayMedia:[],
        contentUrl:[],
        loading:false,
    };

    componentWillMount() {
        this.mapUrlFunction();
        api.user.get_curr()
            .then(resp => {
                this.setState({ user: resp.data })
            })
            .catch(err => null);
    }

    mapUrlFunction =()=>{
        const urlImage = this.props.location.state.urlImage;
        let arrayMedia = [];
        let contentUrl=[];
        urlImage && urlImage.sellout_file && urlImage.sellout_file.length > 0 && urlImage.sellout_file.length != null && urlImage.sellout_file.map((medias, idx) => {
            arrayMedia.push(medias.sellout_file && medias.sellout_file['@id']);
            contentUrl.push(medias.sellout_file && medias.sellout_file.contentUrl);
        });
        urlImage && urlImage.highlight_photo && urlImage.highlight_photo.length > 0  && urlImage.highlight_photo.length != null && urlImage.highlight_photo.map((medias, idx) =>{
            arrayMedia.push(medias.highlight_photo && medias.highlight_photo['@id']);
            contentUrl.push(medias.highlight_photo && medias.highlight_photo.contentUrl);

        });
        urlImage && urlImage.receipt_file && urlImage.receipt_file.length > 0  && urlImage.receipt_file.length != null && urlImage.receipt_file.map((medias, idx) => {
            arrayMedia.push(medias.receipt_file && medias.receipt_file['@id']);
            contentUrl.push(medias.receipt_file && medias.receipt_file.contentUrl);

        });
        urlImage && urlImage.contract_file && urlImage.contract_file.length > 0  && urlImage.contract_file.length != null && urlImage.contract_file.map((medias, idx) => {
            arrayMedia.push(medias.contract_file && medias.receipt_file['@id']);
            contentUrl.push(medias.contract_file && medias.contract_file.contentUrl);
        });
        this.setState({contentUrl:contentUrl,arrayMedia:arrayMedia})
    }

    handleSubmit=() => {
        this.setState({loading:true});
            if(this.props.location.state.type === "CoopOperation" && this.props.location.state.operation.counter && this.props.location.state.operation.counter.counter > 0)
            {
                api.participation.add_multiple(this.props.match.params.ope_id)
                    .then(resp => {
                        this.setState({loading:false});
                        this.props.history.push('/mes-demandes')
                    })
                    .catch(err => console.log(err))

            }
            else
            {
                let filtered = this.state.arrayMedia.filter(function (el) {
                    return el != null;
                });

                const newData = {
                    "operation":this.props.location.state.participation,
                    "declaredQuantity":parseInt(this.props.location.state.urlImage.declaredQuantity),
                    "tickets":filtered
                };
                if (this.props.location.state.opId > 0 ) {
                    newData.edited_id = this.props.location.state.opId;
                }
                api.participation.add_new(newData)
                    .then(resp => {
                        this.setState({loading:false});
                        this.props.history.push('/mes-demandes')
                    })
                    .catch(err => console.log(err))

            }

    };

    render() {
        const { classes, location } = this.props;
        const { user, contentUrl } = this.state;
        const type = location.state.type;
        return (
            <div className={classes.container} style={{padding: '40px'}} >
                <h1 className={classes.title}>Récapitulatif de ma participation</h1>
                <Grid container >
                    <Card>
                        <CardContent style={{marginLeft: '70px'}}>
                            <Grid>
                                <Grid xs={12} sm={12} md={12}>
                                    <h5 style={style.titleRecap}>Les informations de l'opération</h5>
                                    <Grid container>
                                        <Grid xs={12} sm={12} md={4}>
                                            <List >
                                                <ListItemText
                                                    primary="Titre"
                                                    secondary={this.props.location.state.operation.operation.title}
                                                />
                                            </List>
                                        </Grid>
                                        <Grid xs={12} sm={12} md={4}>
                                            <List >
                                                <ListItemText
                                                    primary="Description"
                                                    secondary={this.props.location.state.operation.operation.description}
                                                />
                                            </List>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid xs={12} sm={12} md={12}>
                                    <h5 style={style.titleRecap}>Mes informations personnelles</h5>
                                    <Grid container>
                                        <Grid xs={12} sm={12} md={4}>
                                            <List >
                                                <ListItemText
                                                    primary="CIP"
                                                    secondary={user && user.companyId}
                                                />
                                            </List>
                                        </Grid>
                                        <Grid xs={12} sm={12} md={4}>
                                            <List >
                                                <ListItemText
                                                    primary="Email"
                                                    secondary={user && user.email}
                                                />
                                            </List>
                                        </Grid>
                                        <Grid xs={12} sm={12} md={4}>
                                            <List >
                                                <ListItemText
                                                    primary="Raison Social"
                                                    secondary={user && user.companyName }
                                                />
                                            </List>
                                        </Grid>
                                    </Grid>
                                    <Grid container>
                                        <Grid xs={12} sm={12} md={4}>
                                            <List >
                                                <ListItemText
                                                    primary="Adresse"
                                                    secondary={user && user.address + " " +user.city }
                                                />
                                            </List>
                                        </Grid>
                                        <Grid xs={12} sm={12} md={4}>
                                            <List >
                                                <ListItemText
                                                    primary="Iban"
                                                    secondary={user && user.cachedIban}
                                                />
                                            </List>
                                        </Grid>
                                        <Grid xs={12} sm={12} md={4}>
                                            <List >
                                                <ListItemText
                                                    primary="Bic"
                                                    secondary={user && user.cachedBic}
                                                />
                                            </List>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid xs={12} sm={12} md={12}>
                                    <h5 style={style.titleRecap}>Mes justificatifs</h5>
                                    <Grid container>
                                        {contentUrl.map((medias, idx) =>
                                            <Grid xs={6} sm={6} md={2}>
                                                {medias !== null &&
                                                <Card>
                                                    <CardHeader>
                                                        {medias.split('.').pop() === "pdf" &&
                                                        <img
                                                            style={{height: '100px', cursor: "pointer"}}
                                                            onClick={() => window.open(`${process.env.REACT_APP_BACKEND_URL}/media/${medias}`, '_blank')}
                                                            src={logo} alt="pdf"/>

                                                        }
                                                        {medias.split('.').pop() !== "pdf" &&
                                                        <img
                                                            style={{height: '100px', cursor: "pointer"}}
                                                            onClick={() => window.open(`${process.env.REACT_APP_BACKEND_URL}/media/${medias}`, '_blank')}
                                                            src={`${process.env.REACT_APP_BACKEND_URL}/media/${medias}`}
                                                            alt="image"/>
                                                        }
                                                    </CardHeader>
                                                </Card>
                                                }
                                            </Grid>
                                        )}
                                    </Grid>
                                </Grid>
                                <CardActions style={{margin:'30px auto'}}>
                                    <Button   style={{
                                        backgroundColor: '#319ebb',
                                        padding: '10px',
                                        color: 'white',
                                        fontSize: '13px',
                                        fontWeight: 'bold',
                                        whiteSpace: 'normal',
                                    }} component={Link}
                                            to={{pathname:`/nouvelle-demande/${this.props.match.params.ope_id}`,state:{type}}}
                                    >Modifier ma participation
                                    </Button>
                                    {!this.state.loading &&
                                    <Button
                                        onClick={() => this.handleSubmit()}
                                        style={{
                                            backgroundColor: '#f50082',
                                            padding: '10px',
                                            color: 'white',
                                            fontSize: '13px',
                                            fontWeight: 'bold',
                                            whiteSpace: 'normal',
                                        }}
                                    >Enregistrer ma participation
                                    </Button>
                                    }
                                    {this.state.loading &&
                                    <Button
                                        style={{
                                            backgroundColor: '#f50082',
                                            padding: '10px',
                                            color: 'white',
                                            fontSize: '13px',
                                            fontWeight: 'bold',
                                            whiteSpace: 'normal',
                                        }}
                                    ><CircularProgress style={{color:'white', height:'20px', width:'20px'}} />
                                    </Button>
                                    }
                                </CardActions>
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>
            </div>
        );
    }
}

export default withStyles(style
)(RecapParticipation)



// WEBPACK FOOTER //
// ./src/views/Pages/RecapParticipation.jsx